import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Skills"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "List of Skills and their sub-skills")
], -1)
const _hoisted_3 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_7 = {
  class: "card-toolbar",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  "data-bs-trigger": "hover",
  title: "Click to add a skill category"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    version: "1.1",
    viewBox: "0 0 24 24",
    height: "24px",
    width: "24px",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      xmlns: "http://www.w3.org/2000/svg",
      id: "Oval-5",
      fill: "#000000",
      opacity: "0.3",
      cx: "12",
      cy: "12",
      r: "10"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      xmlns: "http://www.w3.org/2000/svg",
      d: "M11,11 L11,7 C11,6.44771525 11.4477153,6 12,6 C12.5522847,6 13,6.44771525 13,7 L13,11 L17,11 C17.5522847,11 18,11.4477153 18,12 C18,12.5522847 17.5522847,13 17,13 L13,13 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,13 L7,13 C6.44771525,13 6,12.5522847 6,12 C6,11.4477153 6.44771525,11 7,11 L11,11 Z",
      id: "Combined-Shape",
      fill: "#000000"
    })
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Add new Skill ")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.showButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            disabled: _ctx.saving,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('save-weights'))),
            class: "btn btn-sm btn-info me-3"
          }, [
            (_ctx.saving)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5))
              : _createCommentVNode("", true),
            _hoisted_6
          ], 8, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("a", {
          href: "#",
          class: "btn btn-sm btn-success",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('new-skill')))
        }, _hoisted_10)
      ])
    ])
  ]))
}